import "./Heading.css";

const Heading = () => {
  return (
    <div className="heading">
      <p className="heading-title">Your Own Expense Tracker </p>
    </div>
  );
};

export default Heading;
